'use strict';

module.exports = function count() {
  return this.items.length;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/count.js
// module id = 1218
// module chunks = 2